import { ParametreGeneral } from "./../../../models/ParametreGeneral";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FondsPropresService } from "./../../../services/fonds-propres.service";
import { Component, OnInit } from "@angular/core";
import FormData from "form-data";

@Component({
  selector: "app-edit-modal",
  templateUrl: "./edit-modal.component.html",
  styleUrls: ["./edit-modal.component.scss"],
})
export class EditModalComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;
  //From DB
  parametreGeneral: ParametreGeneral;
  constructor(
    private fb: FormBuilder,
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      libelle: [
        this.parametreGeneral.libelleParametre,
        Validators.compose([Validators.required]),
      ],
      valeur: [
        this.parametreGeneral.valeurParametre,
        Validators.compose([Validators.required]),
      ],
    });
  }

  updateData() {
    var formData = new FormData();
    formData.append("id", this.parametreGeneral.id);
    formData.append("codeParametre", this.parametreGeneral.codeParametre);
    formData.append("typeParametre", this.parametreGeneral.typeParametre);
    formData.append("libelleParametre", this.form.value.libelle);
    formData.append("valeurParametre", this.form.value.valeur);
    this.shared.updateParametreGeneral(formData).subscribe(
      (data) => {
        console.log(data);
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }
}
